import moment from "moment";
import { MOMENT_TIME_FORMAT } from "../constants/date_format";

export class yAxis {
    value: any;
    time: any;

    constructor(value, time) {
        this.value = value;
        this.time = moment(time, MOMENT_TIME_FORMAT);
    }
}

export class xAxis {
    value: any;
    dayOfWeek: any;

    constructor(value, dayOfWeek) {
        this.value = value;
        this.dayOfWeek = dayOfWeek;
    }
}



